import RequestAPI from "./request";

/* #region  Login */
export const loginEmail = async (body: { email: string; password: string }) => {
  const response = await RequestAPI.post(
    "/core-user-service/auth/login/email",
    body
  );
  return response.data;
};

export const loginOtpEmail = async (body: {
  verificationId: number;
  email: string;
}) => {
  const response = await RequestAPI.post(
    "/core-user-service/auth/login/otp/email",
    body
  );
  return response.data;
};

export const loginPhone = async (body: { phone: string; password: string }) => {
  const response = await RequestAPI.post(
    "/core-user-service/auth/login/phone",
    body
  );
  return response.data;
};

export const loginOtpPhone = async (body: {
  verificationId: number;
  phone: string;
}) => {
  const response = await RequestAPI.post(
    "/core-user-service/auth/login/otp/phone",
    body
  );
  return response.data;
};

export const loginFacebook = async (data: { accessToken: string }) => {
  const response = await RequestAPI.post(
    "/core-user-service/auth/login/facebook",
    data
  );
  return response.data;
};

export const loginApple = async (data: { idToken: string }) => {
  const response = await RequestAPI.post(
    "/core-user-service/auth/login/apple",
    data
  );
  return response.data;
};

export const loginGoogle = async (data: { accessToken: string }) => {
  const response = await RequestAPI.post(
    "/core-user-service/auth/login/google",
    data
  );
  return response.data;
};

export const loginEmailVerifyOtp = async (data: {
  email: string;
  code: string;
  session_id: number;
}) => {
  const response = await RequestAPI.post(
    "/core-user-service/auth/login/email/verify-otp",
    data
  );
  return response.data;
};

export const loginEmailResendOtp = async (data: { email: string; session_id: number }) => {
  const response = await RequestAPI.post(
    "/core-user-service/auth/login/email/resend-otp",
    data
  );
  return response.data;
};
/* #endregion */

/* #region  Register */
export const registerEmail = async (data: {
  email: string;
  password: string;
  verificationId: number;
}) => {
  const results = await RequestAPI.post(
    "/core-user-service/auth/register/email",
    data
  );
  return results.data;
};

export const registerPhone = async (data: {
  phone: string;
  password: string;
  verificationId: number;
}) => {
  const results = await RequestAPI.post(
    "/core-user-service/auth/register/phone",
    data
  );
  return results.data;
};
/* #endregion */

/* #region  Forgot Password */
export const forgotPasswordEmail = async (data: {
  email: string;
  password: string;
  verificationId: number;
}) => {
  const results = await RequestAPI.post(
    "/core-user-service/auth/forgotPassword/email",
    data
  );
  return results.data;
};

export const forgotPasswordPhone = async (data: {
  phone: string;
  password: string;
  verificationId: number;
}) => {
  const results = await RequestAPI.post(
    "/core-user-service/auth/forgotPassword/phone",
    data
  );
  return results.data;
};
/* #endregion */

/* #region  Verification */
export const verificationRequestEmail = async (data: {
  feature: string;
  email: string;
  token?: string;
}) => {
  const results = await RequestAPI.post(
    "/core-user-service/verification/request/email",
    data
  );
  return results.data;
};

export const verificationRequestPhone = async (data: {
  feature: string;
  phone: string;
  token?: string;
}) => {
  const results = await RequestAPI.post(
    "/core-u" + "ser-service/verification/request/phone",
    data
  );
  return results.data;
};

export const confirmVerification = async (data: {
  verificationId: number;
  feature: string;
  code: string;
}) => {
  const results = await RequestAPI.post(
    "/core-user-service/verification/confirm",
    data
  );
  return results.data;
};
/* #endregion */

/* #region  Profile */
export const updateProfile = async (data: {
  firstName: string;
  lastName: string;
  gender: number;
  birthday: string;
  phone: string;
  email: string;
}) => {
  const results = await RequestAPI.post(
    "/core-user-service/user/profile",
    data
  );
  return results.data;
};

export const getProfile = async () => {
  const results = await RequestAPI.get("/core-user-service/person/profile");
  return results.data;
};

export const getIdentifiers = async () => {
  const results = await RequestAPI.get("/core-user-service/user/identifiers");
  return results.data;
};

export const changePassword = async (data: {
  oldPassword: string;
  newPassword: string;
}) => {
  const results = await RequestAPI.post(
    "/core-user-service/user/changePassword",
    data
  );
  return results.data;
};

export const resetPassword = async (data: {
  verificationId: number;
  password: string;
}) => {
  const results = await RequestAPI.post(
    "/core-user-service/user/resetPassword",
    data
  );
  return results.data;
};
/* #endregion */

/* #region  Link Account to Phone Email Facebook Google Apple */
export const verifyPhone = async (data: {
  verificationId: number;
  phone: string;
}) => {
  const results = await RequestAPI.post(
    "/core-user-service/user/verify/phone",
    data
  );
  return results.data;
};

export const unverifyPhone = async () => {
  const results = await RequestAPI.post(
    "/core-user-service/user/unverify/phone"
  );
  return results.data;
};

export const verifyEmail = async (data: {
  verificationId: number;
  email: string;
}) => {
  const results = await RequestAPI.post(
    "/core-user-service/user/verify/email",
    data
  );
  return results.data;
};

export const unverifyEmail = async () => {
  const results = await RequestAPI.post(
    "/core-user-service/user/unverify/email"
  );
  return results.data;
};

export const verifyFacebook = async (data: { accessToken: string }) => {
  const results = await RequestAPI.post(
    "/core-user-service/user/verify/facebook",
    data
  );
  return results.data;
};

export const unverifyFacebook = async () => {
  const results = await RequestAPI.post(
    "/core-user-service/user/unverify/facebook"
  );
  return results.data;
};

export const verifyApple = async (data: { idToken: string }) => {
  const results = await RequestAPI.post(
    "/core-user-service/user/verify/apple",
    data
  );
  return results.data;
};

export const unverifyApple = async () => {
  const results = await RequestAPI.post(
    "/core-user-service/user/unverify/apple"
  );
  return results.data;
};

export const verifyGoogle = async (data: { accessToken: string }) => {
  const results = await RequestAPI.post(
    "/core-user-service/user/verify/google",
    data
  );
  return results.data;
};

export const unverifyGoogle = async () => {
  const results = await RequestAPI.post(
    "/core-user-service/user/unverify/google"
  );
  return results.data;
};

/* #endregion */

export const checkPhone = async (data: { phone: string }) => {
  const results = await RequestAPI.post(
    "/core-user-service/auth/checkPhone",
    data
  );
  return results.data;
};

export const checkEmail = async (data: { email: string }) => {
  const results = await RequestAPI.post(
    "/core-user-service/auth/checkEmail",
    data
  );
  return results.data;
};

export const articles = async () => {
  const result = await RequestAPI.get(
    "https://micro-services.vntrip.vn/common/articles/"
  );
  return result.data;
};

// WALLET
export const getCustomerBalance = async () => {
  const results = await RequestAPI.get("/ewallet-monitor/account/balance");
  return results.data;
};

export const getCustomerTransaction = async (params: any) => {
  const results = await RequestAPI.get("/ewallet-monitor/account/transaction", {
    params: params,
  });
  return results.data;
};

export const getOrderPending = async (params: any) => {
  const results = await RequestAPI.get(
    "/ewallet-monitor/account/transaction_pending",
    {
      params: params,
    }
  );
  return results.data;
};

export const activeWallet = async () => {
  const results = await RequestAPI.post(
    "/ewallet-worker/customer-wallet/person/active",
    {}
  );
  return results.data;
};

export const getPaymentMethosList = async (params: any) => {
  const results = await RequestAPI.get(`/payment-service/fe/payment-method`, {
    params: params,
  });
  return results.data;
};
export const getPaymentMethodWithFee = async (data: any) => {
  try {
    const results = await RequestAPI.post(
      "/payment-service/fe/payment-method-amount",
      data
    );
    return results.data;
  } catch (e) {
    throw e;
  }
};

export const createOrderTopup = async (data: any) => {
  const results = await RequestAPI.post(
    "/frontend-service/topup/create-order",
    data
  );
  return results.data;
};

export const getOrderData = async (orderId: any) => {
  const results = await RequestAPI.get(
    `/order-hotel/order/${orderId}/by-user/`
  );
  return results.data;
};

export const getOrderDataTransaction = async (transactionId: string) => {
  const results = await RequestAPI.get(
    `/payment-service/payment/v2/${transactionId}`
  );
  return results.data;
};

export const getBankAccount = async () => {
  const results = await RequestAPI.get(`/v2-common/bank-account`);
  return results.data;
};

export const getListBankQR = async () => {
  const results = await RequestAPI.get(`/core-tms-service/qr-code/bank`);
  return results.data;
};

export const createBankQR = async (data: any) => {
  const results = await RequestAPI.post(`/core-tms-service/qr-code`, data);
  return results.data;
};
